const COPY = {
  missing: {
    title: "No artwork",
    sub: {
      detail: "Not available on RingsDB for this card.",
      tile: "Not on RingsDB",
    },
  },
  broken: {
    title: "Artwork unavailable",
    sub: {
      detail: "This image link failed to load (removed or moved).",
      tile: "Image link broken",
    },
  },
};

/** Framed 5×7 placeholder for missing or broken card art. Pass `children` for overlays (e.g. deck buttons). */
export function CardArtPlaceholder({ variant = "detail", reason = "missing", className = "", children }) {
  const block = COPY[reason] ?? COPY.missing;
  const sub = variant === "tile" ? block.sub.tile : block.sub.detail;

  return (
    <div
      className={`relative aspect-[5/7] w-full overflow-hidden rounded-lg border border-dashed border-slate-600/70 bg-slate-950 ${className}`.trim()}
    >
      <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center gap-1.5 px-3 text-center">
        <span
          className={
            variant === "detail"
              ? "text-sm font-medium text-slate-500"
              : "text-xs font-medium text-slate-500"
          }
        >
          {block.title}
        </span>
        <span
          className={
            variant === "detail"
              ? "text-xs leading-snug text-slate-600"
              : "text-[0.65rem] leading-snug text-slate-600"
          }
        >
          {sub}
        </span>
      </div>
      {children}
    </div>
  );
}
